import React from 'react';

import { Box, Button, ButtonGroup, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import useAuth from 'hooks/useAuth';
import useCurrentUser from 'hooks/useCurrentUser';
import { useAppDispatch } from 'store';
import { atualizarDisponibilidadeUsuario } from 'store/reducers/usuarios';

const useStyles = makeStyles(theme => ({
  buttonGroup: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.background.default
        : theme.palette.background.tertiary,
    borderRadius: 24,
    marginTop: 8,
    border: 'none',
    boxShadow: 'none',
    '& .MuiButtonGroup-groupedHorizontal:not(:last-child)': {
      border: 'none',
    },
  },
  button: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    border: 'none !important',
    boxShadow: 'none !important',
    transition: 'all 0.2s ease-in-out',
    padding: '6px 16px',
  },
  activeDisponivel: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  activeIndisponivel: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  inactive: {
    backgroundColor: 'transparent',
    color: '#8C9BA5',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(255, 255, 255, 0.05)'
          : 'rgba(0, 0, 0, 0.04)',
    },
  },
}));

function ToggleDistribuicaoAutomaticaFila() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const currentUser = useCurrentUser();
  const { setCurrentUser } = useAuth();

  const [value, setValue] = React.useState(currentUser?.disponivel);

  const toggleDistribuicaoAutomaticaFila = async (value: boolean) => {
    setValue(value);
    dispatch(atualizarDisponibilidadeUsuario({ disponivel: value }))
      .unwrap()
      .then(response => {
        enqueueSnackbar(response.message);
        if (currentUser) {
          setCurrentUser({ ...currentUser, disponivel: value });
        }
      });
  };

  return (
    <Box px={2} py={1}>
      <Typography variant="body2">Distribuição automática da fila</Typography>

      <ButtonGroup className={classes.buttonGroup} fullWidth disableElevation>
        <Button
          className={`${classes.button} ${
            value ? classes.activeDisponivel : classes.inactive
          }`}
          onClick={() => toggleDistribuicaoAutomaticaFila(true)}
        >
          Disponível
        </Button>

        <Button
          className={`${classes.button} ${
            !value ? classes.activeIndisponivel : classes.inactive
          }`}
          onClick={() => toggleDistribuicaoAutomaticaFila(false)}
        >
          Indisponível
        </Button>
      </ButtonGroup>
    </Box>
  );
}

export default ToggleDistribuicaoAutomaticaFila;
